import { render, staticRenderFns } from "./StockchartMenu.vue?vue&type=template&id=06542ede&scoped=true&"
import script from "./StockchartMenu.vue?vue&type=script&lang=js&"
export * from "./StockchartMenu.vue?vue&type=script&lang=js&"
import style0 from "./StockchartMenu.vue?vue&type=style&index=0&id=06542ede&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06542ede",
  null
  
)

export default component.exports